import type { ComponentPropsWithoutRef, ReactNode } from 'react';

/** Semantic feedback tones for inline alert banners. */
export type AlertTone = 'info' | 'warning' | 'danger' | 'success';

const TONE_CLASS: Record<AlertTone, string> = {
  info: 'alert alert--info',
  warning: 'alert alert--warning',
  danger: 'alert alert--error',
  success: 'alert alert--success',
};

const TONE_ROLE: Record<AlertTone, 'alert' | 'status'> = {
  info: 'status',
  warning: 'alert',
  danger: 'alert',
  success: 'status',
};

export type AlertProps = ComponentPropsWithoutRef<'div'> & {
  children: ReactNode;
  tone?: AlertTone;
};

/** Inline feedback banner for info, warning, danger, and success states. */
export function Alert({
  children,
  tone = 'info',
  className,
  role,
  ...props
}: AlertProps): React.JSX.Element {
  const classes = [TONE_CLASS[tone], className].filter(Boolean).join(' ');
  const resolvedRole = role ?? TONE_ROLE[tone];

  return (
    <div className={classes} role={resolvedRole} {...props}>
      {children}
    </div>
  );
}
